/* Renders a circle avatar with either an image or a name transformed to initials
  Required props:
  - image => url to image
  - initials => string to display in case of no image

  Optional props:
  - size => Height+Width of avatar
  - mobileSize => size of avatar on mobile
  - fontSize => custom fontsize
  - mobileFontSize => custom fontsize on mobile
*/

import React, { Component } from 'react';
import styled from '@emotion/styled';

import { Theme, HFlex } from '../styles';

const Container = styled(HFlex)`
  justify-content: center;
`;

const Image = styled('div')`
  background-image: url('${(props) => props.image}');
  background-repeat: no-repeat;
  height: ${(props) => (props.size ? `${props.size}px` : '50px')};
  width: ${(props) => (props.size ? `${props.size}px` : '50px')};
  background-size: cover;
  background-position: center;
  border-radius: ${(props) => (props.isExperienceSelector ? `0` : '50%')};
  margin-top: 3px;

  /* Support for mobile */
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    ${(props) =>
      props.mobileSize
        ? `height: ${props.mobileSize}px; 
         width: ${props.mobileSize}px; `
        : ''};
  }
`;

const CircleAvatar = styled('div')`
  background-color: ${Theme.colors.black};
  border-radius: 50%;
  color: #fff;
  font-weight: lighter;
  overflow: hidden;
  text-align: center;

  height: ${(props) => (props.size ? `${props.size}px` : '50px')};
  line-height: ${(props) => (props.size ? `${props.size}px` : '50px')};
  top: ${(props) =>
    props.size ? `-${parseInt(props.size, 10) / 4}px` : '50px'};
  width: ${(props) => (props.size ? `${props.size}px` : '50px')};

  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : '24px')};

  /* Support for mobile */
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    ${(props) =>
      props.mobileSize
        ? `height: ${props.mobileSize}px; 
         width: ${props.mobileSize}px; 
         line-height: ${props.mobileSize}px;
         top: -${parseInt(props.mobileSize, 10) / 4}px;`
        : ''};

    ${(props) =>
      props.mobileFontSize ? `font-size: ${props.mobileFontSize}px` : ''}
  }
`;

class Avatar extends Component {
  constructor(props) {
    super(props);

    this.avatarProps = {
      size: this.props.size,
      fontSize: this.props.fontSize,
      mobileSize: this.props.mobileSize,
      mobileFontSize: this.props.mobileFontSize,
    };
  }

  renderInitials = (initials) => {
    return <CircleAvatar {...this.avatarProps}>{initials}</CircleAvatar>;
  };

  renderImage = (imageUrl, _initials) => {
    const { size, className, mobileSize, isExperienceSelector } = this.props;

    return (
      <Container className={className}>
        <Image
          image={imageUrl}
          size={size}
          mobileSize={mobileSize}
          isExperienceSelector={isExperienceSelector}
        />
      </Container>
    );
  };

  render() {
    const { className, imageUrl, initials } = this.props;
    if (imageUrl) return this.renderImage(imageUrl, initials);
    return (
      <Container className={className}>
        {this.renderInitials(initials)}
      </Container>
    );
  }
}

export default Avatar;
